export const PATTERN_TYPES = {
    QUERY: {
        value: 1,
        name: 'Query',
    },
    LBE: {
        value: 2,
        name: 'LBE',
    },
    SEMANTIC: {
        value: 3,
        name: 'Semantic',
    },
    FINETUNED: {
        value: 4,
        name: 'Finetuned',
    },
}

export const PATTERN_TYPES_VALUE_TO_NAME = {
    [PATTERN_TYPES.QUERY.value]: PATTERN_TYPES.QUERY.name,
    [PATTERN_TYPES.LBE.value]: PATTERN_TYPES.LBE.name,
    [PATTERN_TYPES.SEMANTIC.value]: PATTERN_TYPES.SEMANTIC.name,
    [PATTERN_TYPES.FINETUNED.value]: PATTERN_TYPES.FINETUNED.name,
}

export const getPatternTypeName = type => {
    if (PATTERN_TYPES_VALUE_TO_NAME[type]) return PATTERN_TYPES_VALUE_TO_NAME[type]
    return 'Unknown'
}
